const $ = window.$;

const initShipping = () => {
  const selectElement = $('#shipping-countries').on('change', function() {
    const selectedValue = $(this).val();
    $(".shipping-zone.selected").removeClass('selected');
    $('#'+selectedValue).addClass('selected');

    if (selectedValue == 'shipping-zone-TR') {
      $("#turkey-info").show();
    } else {
      $("#turkey-info").hide();
    }
  });

  // get country from url params
  const params = new URLSearchParams(window.location.search);
  if (params && params.get('countryCode')) {
    const selectedCountry = params.get('countryCode').toUpperCase();
    selectElement.val('shipping-zone-' + selectedCountry).trigger('change');
  }
}

$(document).ready(() => {
  initShipping();
});